import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { appConfig } from 'src/app/app.config';
import { AdminService } from 'src/app/Services/admin.service';
import { AuthService } from 'src/app/Services/auth.service';
import { LoaderService } from 'src/app/Services/loader.service';
import { WebsiteService } from 'src/app/Services/website.service';

@Component({
  selector: 'app-manage-regional-reporting',
  templateUrl: './manage-regional-reporting.component.html',
  styleUrls: ['./manage-regional-reporting.component.css']
})
export class ManageRegionalReportingComponent implements OnInit {
  base_address: string = appConfig.apiUrl + 'admin/';

  formData:FormData = new FormData();

  quarter:Number = null;
  year:Number = null;
  reportingItem:any;
  kpIsReportingFeedback:any;
  kpIsReportingFeedbackHistory:any = [];
  kpIsReportingFeedbackNow:any = [];
  kpIsReportingDocs:any;
  bcKPIReportingsDetails:any = [];
  userActions:any;
  savedCheck:boolean = false;
  myKpis:any;
  selectedKpi:any={id: null};
  kpiStatuses:any;

  reportingItemReady:Boolean = false;
  emptyReporting:Boolean = false;

  roleName:string = '';

  coordfeedback:string;
  focalfeedback:string;
  wrfeedback:string;
  comment:string;

  definition:string;
  target:string;
  greenthresholdValue:string;
  yellowthresholdValue:string;
  redthresholdValue:string;
  selectedKpiOutput:string;
  selectedBcType=0;

  requestAdviseFrom:string;
  requestNotes='';
  yearsList:any;

  constructor(private loader: LoaderService,
    private route: ActivatedRoute,
    private adminser: AdminService,
    private toastr: ToastrService,
    private websiteservice: WebsiteService,
    private authService: AuthService) { }

  ngOnInit() {
    this.authService.getUser2().subscribe((data:any) => {
      this.adminser.GetUserBasicInfo(data.profile.oid).subscribe((data:any) => {
        this.roleName = data.result.roleName;
      })
    })
    // this.roleName = localStorage.getItem('role');

    setTimeout(() => {
      this.loader.hideLoader();
    }, 300);
    this.adminser.LoadYearsList().subscribe((data:any) => {
      this.yearsList = data.result;
      this.year = (new Date()).getFullYear() - 1;
      this.quarter = 4;//Math.floor(((new Date()).getMonth() +1) / 4)+1;
      let KpiId = this.route.snapshot.params['kpiId'];
      let year = this.route.snapshot.params['year'];
      let quarter = this.route.snapshot.params['quarter'];
      if(KpiId && year && quarter)
      {
        this.year = year;
        this.quarter = quarter;
        this.filterKpi(KpiId);
      }
    });
    this.myKpis = this.route.snapshot.data.data.result;
  }

  filterKpi(id){
    this.selectedKpi = this.myKpis.filter((item) => item.id == id)[0];
    this.GetReportingItem();
  }


  GetReportingItem(){
    if(!this.year){
      this.toastr.error('Please Select Year.');
      return;
    }
    else if (!this.quarter){
      this.toastr.error('Please Select Quarter.');
      return;
    }
    else if (this.myKpis.length == 0){
      this.toastr.error('There is no KPIs assigned to this Budget Center');
      return;
    }
    else if (this.selectedKpi.id == null){
      this.toastr.error('Please Select KPI.');
      return;
    }
    this.adminser.GetActiveKpiStatuses().subscribe((data: any) => {
      this.kpiStatuses = data.result;
    });
    this.loader.showLoader();
    this.adminser.LoadRegionalReportingItem(this.quarter, this.year, this.selectedKpi.id)
    .subscribe((data: any) => {      
      this.reportingItem = data.result.kpiReporting;
      this.bcKPIReportingsDetails = data.result.bcKpisReportings;
      this.reportingItemReady = true;
      if(this.reportingItem != null){
        this.emptyReporting = false;
        this.kpIsReportingFeedback = this.reportingItem.kpIsReportingFeedback;
        this.kpIsReportingFeedbackHistory = this.kpIsReportingFeedback.filter((item)=> item.history);
        this.kpIsReportingFeedbackNow = this.kpIsReportingFeedback.filter((item)=> !item.history);
          this.wrfeedback='';
          this.focalfeedback='';
          this.coordfeedback ='';

        if(this.kpIsReportingFeedback.filter((item) => !item.history && item.roleName == 'BC Kpi Coordinator')[0])
          this.coordfeedback = this.kpIsReportingFeedback.filter((item) => !item.history && item.roleName == 'BC Kpi Coordinator')[0].feedback;

        if(this.kpIsReportingFeedback.filter((item) => !item.history && item.roleName == 'BC Manager')[0])
          this.wrfeedback = this.kpIsReportingFeedback.filter((item) => !item.history && item.roleName == 'BC Manager')[0].feedback;

        if(this.kpIsReportingFeedback.filter((item) => !item.history && item.roleName == 'Regional Focal Point')[0])
          this.focalfeedback = this.kpIsReportingFeedback.filter((item) => !item.history && item.roleName == 'Regional Focal Point')[0].feedback;

        this.kpIsReportingDocs = this.reportingItem.kpisReportingDocuments;
        if(this.reportingItem.progress)
          this.savedCheck = true;
      }
      else{
        this.reportingItem = {
          progress: '',
          results: '',
          risksAndIssues: '',
          nextSteps: '',
          context: '',
          scoreCardScore: 0,
          kpiStatusId: 0,
          };
        let calculatedStatus = data.result.calculatedStatusId;
        if(calculatedStatus != null)
          this.reportingItem.kpiStatusId = calculatedStatus;
        this.emptyReporting = true;

      }
      this.userActions = data.result.userActions;
      this.definition = data.result.definition;
      this.target = data.result.currentTarget;
      this.greenthresholdValue = data.result.greenThresholdValue;
      this.yellowthresholdValue = data.result.yellowThresholdValue;
      this.redthresholdValue = data.result.redThresholdValue;
      this.selectedKpiOutput = data.result.kpiOutput;
      this.selectedBcType = data.result.budgetCenterType;
      //this.isNotRelevantKpi = data.result.isNotRelevant;
      if(this.year != (new Date()).getFullYear() -1 || this.quarter != 4)
      {
        this.userActions.canCreate = false;
        this.userActions.canEdit = false;
      }
      this.loader.hideLoader();
    },()=>{
      this.reportingItemReady = false;
      this.loader.hideLoader();
    })
  }

checkValidReportingItem()
{
  if(this.reportingItem.kpiStatusId == 0 )
  {
    this.toastr.error('Kpi status is required');
    return false;
  }
  // if(this.reportingItem.scoreCardScore == 0)
  // {
  //   this.toastr.error('Scorecard score is required');
  //   return false;
  // }
  // if(this.reportingItem.context.length == 0)
  // {
  //   this.toastr.error('Context is required');
  //   return false;
  // }
  // if(this.reportingItem.progress.length == 0)
  // {
  //   this.toastr.error('Progress is required');
  //   return false;
  // }
  // if(this.reportingItem.results.length == 0)
  // {
  //   this.toastr.error('Results is required');
  //   return false;
  // }
  // if(this.reportingItem.risksAndIssues.length == 0)
  // {
  //   this.toastr.error('Challenges is required');
  //   return false;
  // }
  // if(this.reportingItem.nextSteps.length == 0)
  // {
  //   this.toastr.error('Next steps is required');
  //   return false;
  // }
  return true;

}

  saveDraft(){
    this.loader.showLoader();
    this.adminser.SaveRegionalAsDraft(this.emptyReporting, this.reportingItem, this.selectedKpi.id, this.quarter, this.year,true)
    .subscribe((data:any) => {
      if(this.formData){
        this.adminser.UploadRegionalEvidences(this.formData, data.result.id).subscribe((res) => {
          this.toastr.success("Data saved as draft");
        })
      }
      else{
        this.toastr.success("Data saved as draft");
      }
      this.GetReportingItem();
      this.loader.hideLoader();
    },
    (err:any) => {
      try{
        let error = JSON.parse(err.error).error.errors;
        for(let i=0; i<error.length; i++){
          this.toastr.error(error[i]);
        }

      }
      catch{
        this.toastr.error('unknown error');
      }
  this.loader.hideLoader();

    })
  }

  submitWorkFlow(accept:boolean){
    if(this.roleName == 'BC Kpi Coordinator'){
      this.comment = this.coordfeedback;
    }
    else if(this.roleName == 'BC Manager'){
      this.comment = this.wrfeedback;
    }
    else if(this.roleName == 'Regional Focal Point'){
      this.comment = this.focalfeedback;
    }
    this.loader.showLoader();
    this.adminser.SubmitRegionalWorkflow(this.reportingItem.id, this.comment , accept).subscribe((data:any) => {
      if(accept){
        this.toastr.success('Reporting Item Accepted Successfully.');
      }
      else{
        this.toastr.success('Reporting Item Rejected Successfully.');
      }
      this.loader.hideLoader();

      setTimeout(()=>{
        window.location.reload()
      }, 500)
    })
  }

  publishWorkflow(){
    if(this.userActions.canCreate || this.userActions.canEdit){
      if(!this.checkValidReportingItem())
      {
        return;
      }
    this.loader.showLoader();

      this.adminser.SaveRegionalAsDraft(this.emptyReporting, this.reportingItem, this.selectedKpi.id, this.quarter, this.year,false).subscribe((data: any) => {
        this.adminser.PublishRegionalWorkflow(data.result.id).subscribe((res: any) => {
          this.toastr.success('Reporting Item Published Successfully.');
          this.GetReportingItem();
          this.loader.hideLoader();

        })
      })
    }
    else{
    this.loader.showLoader();

      this.adminser.PublishRegionalWorkflow(this.reportingItem.id).subscribe((data:any) => {
        this.toastr.success('Reporting Item Published Successfully.');
        this.GetReportingItem();
    this.loader.hideLoader();

      })
    }
  }

  sendClearence(){
    if(!this.checkValidReportingItem())
    {
      return;
    }
    this.loader.showLoader();

    this.adminser.SaveRegionalAsDraft(this.emptyReporting, this.reportingItem, this.selectedKpi.id, this.quarter, this.year,false).subscribe((data:any) => {
      if(this.formData){
        this.adminser.UploadRegionalEvidences(this.formData, data.result.id).subscribe((res) => {
          this.toastr.success("Data sent for clearence");
        })
      }
      else{
        this.toastr.success("Data sent for clearence");
      }
      this.adminser.sendRegionalForClearence(data.result.id).subscribe((res:any) => {
        // this.toastr.success('Reporting Item sent for clearence successfully.');
        this.GetReportingItem();
    this.loader.hideLoader();

      })
    })
  }

  fileChange(event){
    let fileList: FileList = event.target.files;

    for (let i = 0; i < fileList.length; i++) {
      this.formData.append(fileList[i].name, fileList[i])
    }
  }

  downloadDoc(id){
    this.websiteservice.DownloadRegionalEvidence(id).subscribe((data) => {
    })
  }

  requestAdvise(){
    if(this.requestAdviseFrom.length == 0)
    {
     this.toastr.error('please enter an email to request advise from');
     return;
    }
    if(this.reportingItem == null)
    {
      this.toastr.error('invalid reporting item');
      return;
    }
    this.loader.showLoader();

    this.adminser.requestRegionalAdvise(this.reportingItem.id,this.requestAdviseFrom, this.requestNotes).subscribe((result)=>{
      this.toastr.success('email sent successfully');
    this.loader.hideLoader();

    },
      (err:any) => {
        let error = JSON.parse(err.error).error.errors;
        for(let i=0; i<error.length; i++){
          this.toastr.error(error[i]);
        }
    this.loader.hideLoader();

      })
  }

}
